import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.UTIL_SERVER_PREFIX}/api-request-log`
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    apiRequestLogDataList: () => `${RESOURCE_ENDPOINT}/api-request-log-data-list`,
    monitoringApiEndpointDataList: () => `${RESOURCE_ENDPOINT}/monitoring-api-endpoint-data-list`,
    monitoringBrowserUrlDataList: () => `${RESOURCE_ENDPOINT}/monitoring-browser-url-data-list`,
    monitoringIpAddressDataList: () => `${RESOURCE_ENDPOINT}/monitoring-ip-address-data-list`,
    monitoringUniqueDeviceDataList: () => `${RESOURCE_ENDPOINT}/monitoring-unique-device-data-list`,
    monitoringSummeryDataList: () => `${RESOURCE_ENDPOINT}/monitoring-summery-data-list`,
    monitoringUserDataList: () => `${RESOURCE_ENDPOINT}/monitoring-user-data-list`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
}

export default class ApiRequestLogApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    }

    public apiRequestLogDataList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.apiRequestLogDataList();
        return HttpService.get(url, params, headers);
    }

    public monitoringApiEndpointDataList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.monitoringApiEndpointDataList();
        return HttpService.get(url, params, headers);
    }

    public monitoringBrowserUrlDataList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.monitoringBrowserUrlDataList();
        return HttpService.get(url, params, headers);
    }

    public monitoringIpAddressDataList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.monitoringIpAddressDataList();
        return HttpService.get(url, params, headers);
    }

    public monitoringUniqueDeviceDataList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.monitoringUniqueDeviceDataList();
        return HttpService.get(url, params, headers);
    }

    public monitoringSummeryDataList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.monitoringSummeryDataList();
        return HttpService.get(url, params, headers);
    }

    public monitoringUserDataList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.monitoringUserDataList();
        return HttpService.get(url, params, headers);
    }

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    }

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    }

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    }

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    }

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    }

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    }
}
